import React, { Component } from 'react'
import { filter, includes } from 'lodash'
import Checkbox from './Checkbox'
import InputLabel from './InputLabel'

interface CheckboxGroupItem {
  name: string
  label: string
}

interface Props {
  label?: string
  checks: CheckboxGroupItem[]
  checkeds: CheckboxGroupItem['name'][]
  onChange: (checkeds: any[]) => void
}

export default class CheckboxGroup extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
  }

  handleCheckboxChange (name: string) {
    const checked = includes(this.props.checkeds, name)
    if (checked) {
      const checkeds = filter(this.props.checkeds, checked => checked !== name)
      this.props.onChange(checkeds)
    } else {
      this.props.onChange([...this.props.checkeds, name])
    }
  }

  checkbox (check: CheckboxGroupItem) {
    const checked = includes(this.props.checkeds, check.name)
    return (
      <Checkbox
        name={check.name}
        label={check.label}
        checked={checked}
        align="start"
        onChange={this.handleCheckboxChange}
        key={check.name} />
    )
  }

  get label () {
    const { label } = this.props
    return label &&
      <InputLabel text={label} />
  }

  get checkboxes () {
    return this.props.checks.map(check => this.checkbox(check))
  }

  render () {
    return (
      <div className="mb-4">
        {this.label}
        <div className="flex gap-2">
          {this.checkboxes}
        </div>
      </div>
    )
  }
}
